import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';
import { LabelingModel } from './BatchServices'; // Adjust the import path as necessary
export interface SearchFilterResponseModel {
    Id: number;
    Description: string;
    DocumentId: string;
    UniqueId: string;
    PublishStartDate: string | null;
    PublishEndDate: string | null;
    Sources: any[];
    SourceTypes: any[];
    Entities: any[];
    Labels: any[];
    Users: any[];
    Countries: any[];
    DocumentStatus: any[];
    AnnotationStatus: any[];
    QAStatus: number;
    FlaggedStatus: number;
    CommentStatus: number;
    LastUpdateStartDate: string | null;
    LastUpdateEndDate: string | null;
}
interface SearchFilterRequestModel {
    Id: number;
    Description: string;
    DocumentId: string;
    UniqueId: string;
    PublishStartDate: string | null;
    PublishEndDate: string | null;
    Sources: number[];
    SourceTypes: number[];
    Entities: number[];
    Labels: number[];
    Users: number[];
    Countries: number[];
    DocumentStatus: number[];
    AnnotationStatus: number[];
    QAStatus: number;
    FlaggedStatus: number;
    CommentStatus: number;
    LastUpdateStartDate: string | null;
    LastUpdateEndDate: string | null;
}
export interface BaseItemModel {
    Id: number;
    Description: string;
}
export class SearchService {

    axios = useAxios();

    // Define the notification hook
    notification = useNotification();
    async ExecuteSearch(filterModel: SearchFilterRequestModel): Promise<any> {
        try {
            const response = await this.axios.post(config.API_LABELING_URL + "/api/Searches/ExecuteSearch", filterModel);
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422){
                this.notification.showNotification("Error executing search: " + error.response.data?.detail, 'warning');
            }
            else{
                this.notification.showNotification("Error executing search: " + error, 'error');
            }
            throw error;
        }
    }

    async GetCountResults(): Promise<number> {
        try {
            const response = await this.axios.get(config.API_LABELING_URL + "/api/SearchResults/Count");
            return response.data;
        }
        catch (error:any) {
            this.notification.showNotification("Error getting search results count: " + error, 'error');
            throw error;
    }
}

    async CreateSearch(filterModel: SearchFilterRequestModel): Promise<any> {
        try {
            if(filterModel.Description === "") {
                this.notification.showNotification("Search name is required", 'warning');
               return false;
            }
            const response = await this.axios.post(config.API_LABELING_URL + "/api/Searches", filterModel);
            this.notification.showNotification("Search added successfully", 'info');
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422){
                this.notification.showNotification("Error saving search: " + error.response.data?.detail, 'warning');
            }
            else{
                this.notification.showNotification("Error saving search: " + error, 'error');
            }
            throw error;
        }
    }

    async UpdateSearch(filterModel: SearchFilterRequestModel): Promise<any> {
        try {
            const response = await this.axios.put(config.API_LABELING_URL + "/api/Searches", filterModel);
            this.notification.showNotification("Search updated successfully", 'info');
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422){
                this.notification.showNotification("Error updating search: " + error.response.data?.detail, 'warning');
            }
            else{
                this.notification.showNotification("Error updating search: " + error, 'error');
            }
            throw error;
        }
    }

    async RenameSearch(id: number, name: string): Promise<any> {
        try {
            const response = await this.axios.put(config.API_LABELING_URL + "/api/Searches/RenameSearch/" + id,  name);
            this.notification.showNotification("Search renamed successfully", 'info');
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422){
                this.notification.showNotification("Error renaming search: " + error.response.data?.detail, 'warning');
            }
            else{
            this.notification.showNotification("Error renaming search: " + error, 'error');
            }
            throw error;
    }
}

    async DeleteSearch(id: number): Promise<any> {
        try {
            const response = await this.axios.delete(config.API_LABELING_URL + "/api/Searches/" + id);
            this.notification.showNotification("Search deleted successfully", 'info');
            return response.data;
        }
        catch (error:any) {
            if(error?.response?.status === 422){
                this.notification.showNotification("Error deleting search: " + error.response.data?.detail, 'warning');
            }
            else{
                this.notification.showNotification("Error deleting search: " + error, 'error');
            
            }
            throw error;
        }
    }

    async GetSearch(id: number): Promise<SearchFilterResponseModel> {
        try {
            const response = await this.axios.get(config.API_LABELING_URL + "/api/Searches/" + id);
            return response.data;
        }
        catch (error:any) {
            this.notification.showNotification("Error getting search: " + error, 'error');
            throw error;
        }
    }

    async GetCurrentFilters(): Promise<SearchFilterResponseModel> {
        try {
            const response = await this.axios.get(config.API_LABELING_URL + "/api/Searches/MyCurrentSearchFilters");
            return response.data;
        }
        catch (error:any) {
            this.notification.showNotification("Error getting searches: " + error, 'error');
            throw error;
        }
    }

    async GetUserSearches(): Promise<BaseItemModel[]> {
        try {
            const response = await this.axios.get(config.API_LABELING_URL + "/api/Searches/MySearches");
            return response.data;
        }
        catch (error:any) {
            this.notification.showNotification("Error getting searches: " + error, 'error');
            throw error;
        }
    }

    async BrowseResults(documentId?: number): Promise<LabelingModel> {
        try {
                const response = await this.axios.get(config.API_LABELING_URL + "/api/Searches/BrowseResultsByDocumentId/" + (documentId?documentId:""));
                return response.data;
            }
        catch (error:any) {
            this.notification.showNotification("Error browsing search results: " + error, 'error');
            throw error;
        }
    }
    async BrowseResultsEnricher(labelingModel: LabelingModel): Promise<LabelingModel> {
        try {
                const response = await this.axios.post(config.API_LABELING_URL + "/api/Searches/BrowseResultsEnrichment/" , labelingModel);
                return response.data;
            }
        catch (error:any) {
            this.notification.showNotification("Error browsing search results: " + error, 'error');
            throw error;
        }
    }
    
}